import React from 'react';
import { BubbleNavigation } from '../BubbleUI';
import { useActiveProperty } from '@go-client/context/ActivePropertyContext';
import { getPropertyConfiguration } from '@go-shared/lib/propertyConfig';
import { canViewPropertySettingsTab } from '@go-shared/lib/permissions';
import { useUserInfo } from '@go-client/context/UserInfoContext';
import {
  resolveItinerariesPath,
  resolvePropertySettingsPath,
  resolveTemplatesPath,
} from '@go-client/routes';

export default function ItineraryNavigation(props: {
  active: 'itinerary' | 'templates' | 'property-config';
}) {
  const { activeProperty: property } = useActiveProperty();
  const { user } = useUserInfo();

  const itineraryLabel = getPropertyConfiguration(property.type, 'itineraryLabel');

  return (
    <BubbleNavigation
      items={[
        {
          name: itineraryLabel,
          to: resolveItinerariesPath(property._id),
          active: props.active === 'itinerary',
        },
        {
          name: 'Templates',
          to: resolveTemplatesPath(property._id),
          active: props.active === 'templates',
          variant: 'velvet',
        },
        {
          name: 'Settings',
          to: resolvePropertySettingsPath(property._id),
          hide: !canViewPropertySettingsTab(user),
          active: props.active === 'property-config',
        },
      ]}
    />
  );
}
